module.exports = __webpack_public_path__ + "static/media/me.28378a1f.jpg";